// Views

import blockCarousel from '../components/blockCarousel'
import footerCarousel from '../components/footerCarousel'
import ingredientsList from '../components/ingredientsList'
import modalVideo from '../components/modalVideo'
import notification from '../components/notification'
import postCarousel from '../components/postCarousel'
import scrollIndicator from '../components/scrollIndicator'
import share from '../components/share'
import videoPlayer from '../components/videoPlayer'

// Components

// Class

const glob = {
  init() {
    ingredientsList.init()
    scrollIndicator.init()
    notification.init()
    share.init()
    modalVideo.init()
    videoPlayer.init()
  },
  load() {
    blockCarousel.init()
    postCarousel.init()
    footerCarousel.init()
  }
}
export default glob
